import mediaTypesAPI from '@/api/artist/media-types';
import * as templateAPI from '@/api/artist/templates-edit';

const state = {
  allMediaTypes: [],
  priceTemplates: [],
  validations: [],
  template: {
    id: null,
    name: '',
    type: 'price',
    default: false,
    items: [],
  },
  itemsToDelete: [],
  itemsToUpdate: [],
  // itemsToCreate: [],
  filters: [],
  loading: false,
  videoFormats: ['sd', 'hd', '2k', '4k'],
};

const getters = {
  getPriceTemplateByKey({ priceTemplates }) {
    return (id) => priceTemplates.find(x => x.id === id);
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  set(state, template) {
    template.items = template.items ? template.items : [];
    state.template = template;
  },
  setId({ template }, id) {
    template.id = id;
  },
  update({ template }, { key, value }) {
    template[key] = value;
  },
  reset(state) {
    state.template.id = null;
    state.template.name = '';
    state.template.default = false;
    state.template.items = [];
    state.itemsToDelete = [];
    state.itemsToUpdate = [];
    state.validations = [];
  },
  addItem({ template: { items } }, item) {
    item.id = `tempId-${Math.round(Math.random() * 1000000)}`;
    items.push(item);
  },
  updateItemValue({ template: { items }, itemsToUpdate }, { id, tempId, value }) {
    const identificator = id ? 'id' : 'tempId';
    const identificatorValue = id ? id : tempId;
    if (tempId) {
      const targetItem = items.find(item => item[identificator] === identificatorValue);
      targetItem.value = value;
    } else {
      const targetItem = itemsToUpdate.find(item => item[identificator] === identificatorValue);
      if (targetItem) {
        targetItem.value = value;
      } else {
        itemsToUpdate.push({ id, value });
      }
    }
  },
  // eslint-disable-next-line
  updateItemKey({ template: { items }, itemsToUpdate }, { id, tempId, key, value }) {
    const identificator = id ? 'id' : 'tempId';
    const identificatorValue = id ? id : tempId;
    if (tempId) {
      const targetItem = items.find(item => item[identificator] === identificatorValue);
      targetItem.key = key;
    } else {
      const targetItem = itemsToUpdate.find(item => item[identificator] === identificatorValue);
      if (targetItem) {
        targetItem.key = key;
      } else {
        itemsToUpdate.push({ id, key, value });
      }
    }
  },
  removeItem({ template: { items } }, id) {
    const index = items.findIndex(item => item.id === id);
    if (index > -1) items.splice(index, 1);
  },
  updateItemsToDelete({ itemsToDelete }, item) {
    const index = itemsToDelete.findIndex(x => x.id === item.id);
    if (index < 0) itemsToDelete.push(item);
  },
  resetItemsToDelete(state) {
    state.itemsToDelete = [];
  },
  setPriceTemplates(state, list) {
    state.priceTemplates = list;
  },
  setMediaTypes(state, mediaTypes) {
    state.allMediaTypes = mediaTypes;
  },
  updateValidations({ validations }, payload) {
    const index = validations.findIndex(v => v.id === payload.id);
    if (index < 0) {
      validations.push(payload);
    } else {
      validations.splice(index, 1, payload);
    }
  },
  removeValidation({ validations }, id) {
    const index = validations.findIndex(v => v.id === id);
    if (index > -1) validations.splice(index, 1);
  },
  resetValidations(state) {
    state.validations = [];
  },
  //
  resetItemsToUpdate(state) {
    state.itemsToUpdate = [];
  },
};

const actions = {
  async get({ commit }, id) {
    const template = await templateAPI.getTemplate(id);
    commit('set', template);
  },
  async create({ commit }, payload) {
    const response = await templateAPI.createTemplate(payload);
    commit('setId', response.data.data.id);
    return response;
  },
  async deleteTemplate(state, params) {
    const response = await templateAPI.deleteTemplate(params);
    return response;
  },
  update(state, payload) {
    return templateAPI.updateTemplate(payload);
  },
  createItem(state, { templateId, data }) {
    return templateAPI.createTemplateItem(templateId, data);
  },
  async updateItem(state, { templateId, itemId, data }) {
    return templateAPI.updateTemplateItem(templateId, itemId, data);
  },
  async deleteItem(state, { templateId, itemId }) {
    return templateAPI.deleteTemplateItem(templateId, itemId);
  },
  async getPricingTiers({ commit }) {
    const response = await mediaTypesAPI.all({ 'fields[media_type]': 'pricing' });
    commit('setPricingTiers', response.data.data);
  },
  async getPriceTemplates({ commit }, params) {
    const response = await templateAPI.listPriceTemplates(params);
    commit('setPriceTemplates', response.data.data);
  },
  async getAllMediaTypes({ commit }, type) {
    const response = await mediaTypesAPI.all({ 'fields[media_type]': type });
    commit('setMediaTypes', response.data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
